import { Link } from 'react-router-dom';
import crest from '../assets/logo.jpg';
import { school } from '../constants/school.js';

/*
 * The school crest plus the wordmark. The crest carries the name and the "we
 * walk for the world" ribbon itself, but neither is legible at 40px — the text
 * lockup beside it is the readable version, so the crest is decorative.
 *
 * The artwork is a circle on a pale square, so it is scaled slightly past the
 * clip to lose that border. On the dark footer it gets a gold rim to separate
 * it from the background.
 */
export default function Logo({ tone = 'light', to = '/' }) {
  const dark = tone === 'dark';

  return (
    <Link to={to} className="flex flex-none items-center gap-3">
      <span
        className={[
          'block flex-none overflow-hidden rounded-full',
          dark
            ? 'size-10 border-2 border-sun'
            : 'size-11 shadow-[0_3px_0_var(--color-forest-deep)]',
        ].join(' ')}
      >
        <img
          src={crest}
          alt=""
          aria-hidden="true"
          className="size-full scale-105 object-cover"
        />
      </span>
      <span className="block">
        <span
          className={`block font-display font-extrabold leading-none ${
            dark ? 'text-[18px] text-cream' : 'text-[19px] text-forest'
          }`}
        >
          {school.name}
        </span>
        <span
          className={`block font-hand text-sm leading-tight ${dark ? 'text-sun' : 'text-coral'}`}
        >
          {school.tagline}
        </span>
      </span>
    </Link>
  );
}
